export const GET_SECTION_REQUEST = 'GET_SECTION_REQUEST';
export const GET_SECTION_REQUEST_SUCCESS = 'GET_SECTION_REQUEST_SUCCESS';
export const GET_SECTION_REQUEST_ERROR = 'GET_SECTION_REQUEST_ERROR';
